<div class="header-bar">
  <div class="header-left">
    <div class="header-text">Beacons</div>
    <div class="divider"></div>
    <div class="search-box input-box">
      <svg-icon src="assets/svg/magnifier.svg"></svg-icon>

      <mat-form-field>
        <input matInput type="text" [formControl]="searchValueControl" />
      </mat-form-field>
    </div>
    <div class="divider"></div>
    <div class="filter">
      <button mat-button class="icon-btn" (click)="toggleFilterDialog()">
        <svg-icon src="assets/svg/filter.svg" svgClass="grey"></svg-icon>
      </button>
    </div>
  </div>
  <div class="header-center"></div>
  <div class="header-right">
    <button
      *ngIf="showCreate"
      mat-button
      color="lightGreen"
      (click)="createNewBeacon()"
    >
      Create New Beacon
    </button>
  </div>
</div>

<div class="beacons-list">
  <div class="container beacons-container">
    <div class="container-header no-bottom-border">
      <div class="text">Existing Beacons</div>
      <div class="options">
        <button
          *ngIf="showCreate"
          mat-icon-button
          [matMenuTriggerFor]="beaconsMenu"
        >
          <svg-icon src="assets/svg/ellipsis.svg"></svg-icon>
        </button>
        <mat-menu
          class="mat-menu-elaphant vertical-menu"
          #beaconsMenu="matMenu"
        >
          <button
            *ngIf="showCreate"
            class="icon-btn-w-text"
            mat-menu-item
            (click)="createNewBeacon()"
          >
            <svg-icon src="assets/svg/plus-circle-white.svg"></svg-icon>
            <span>Create New Beacon</span>
          </button>
        </mat-menu>
      </div>
    </div>

    <div
      class="container-content"
      lhpeElementLoader
      #beaconElementLoader="elementloader"
    >
      <table #beaconsTable mat-table [dataSource]="beaconsDataSource" matSort>
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef>ID</th>
          <td mat-cell *matCellDef="let element">
            {{ element.id }}
          </td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Beacon Name</th>
          <td mat-cell *matCellDef="let element">
            {{ element.name }}
          </td>
        </ng-container>

        <ng-container matColumnDef="facility_floors.name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Facility Floor
          </th>
          <td mat-cell *matCellDef="let element">
            <span *ngIf="element.facilityFloor.id != undefined">
              {{ element.facilityFloor.facility.name }} /
              {{ element.facilityFloor.name }}
            </span>
            <span *ngIf="element.facilityFloor.id == undefined"> - </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="options">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element" class="options-cell">
            <button
              *ngIf="showEdit"
              mat-button
              (click)="edit(element)"
              class="icon-btn"
            >
              <svg-icon
                src="assets/svg/pencil.svg"
                svgClass="lightBlue"
              ></svg-icon>
            </button>
            <div *ngIf="!showEdit" class="empty-btn-space"></div>

            <button
              *ngIf="showDelete"
              mat-button
              (click)="delete(element)"
              class="icon-btn"
            >
              <svg-icon
                src="assets/svg/trashcan.svg"
                [svgStyle]="{
                  'width.px': '15.25',
                  'height.px': '16.204'
                }"
                svgClass="lightBlue"
              ></svg-icon>
            </button>
            <div *ngIf="!showDelete" class="empty-btn-space"></div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
      <mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="perPage" (page)="onPageChange($event)"></mat-paginator>
    </div>
  </div>
</div>
